import classNames from 'classnames'
import { ReactElement, useId } from 'react'
import { AISparkle } from 'app/components/Icon/AIBadgeIcon'

type Props = {
  workflowName: string
  className?: string
}

export function AgentEngagedDivider({ workflowName, className }: Props): ReactElement {
  const gradientId = `agent-engaged-sparkle-${useId()}`

  return (
    <div data-testid="agent-engaged-divider" className={classNames(`flex items-center`, className)}>
      <div className="h-px w-full bg-ai-accent-light" />
      <div className="flex shrink-0 items-center gap-1 rounded border-[0.5px] border-ai-accent-light bg-surface-muted px-1.5 py-0.5">
        <AISparkle className="h-4 w-4 shrink-0" gradientId={gradientId} />
        <span className="whitespace-nowrap text-center text-label-xs font-medium text-blue-700">
          Agent Engaged: {workflowName}
        </span>
      </div>
      <div className="h-px w-full bg-ai-accent-light" />
    </div>
  )
}
